/**
 * Visually distinct keyboard-shortcut chip used in both windowed
 * onboarding banners (e.g. `hotkey-tip-banner`) and the fullscreen
 * action column (P / R / K / Q tags on each button).
 *
 * Extracted to its own module on 2026-05-13 (after iter-30 caught a
 * bug from re-exporting it through `FullscreenHud.jsx`). Keeping it in
 * `./ui/KeyBadge.jsx` means every caller imports from a neutral
 * location and the dependency graph stays acyclic.
 */
export function KeyBadge({ k, color = "#ffffff" }) {
  return (
    <span
      className="ml-1 inline-flex items-center justify-center px-1.5 py-0.5 text-[10px] font-mono-cosmic font-bold leading-none tabular-nums"
      style={{
        color,
        background: `${color}22`,
        border: `1px solid ${color}70`,
        borderRadius: "3px",
        minWidth: "1.4em",
      }}
      aria-hidden="true"
      data-testid={`key-badge-${k}`}
    >
      {k}
    </span>
  );
}
